/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniDocumentChartBar = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-document-chart-bar ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M3 3.5C3 2.67157 3.67157 2 4.5 2H11.3787C11.7765 2 12.158 2.15804 12.4393 2.43934L16.5607 6.56066C16.842 6.84197 17 7.2235 17 7.62132V16.5C17 17.3284 16.3284 18 15.5 18H4.5C3.67157 18 3 17.3284 3 16.5V3.5ZM13.25 9C13.6642 9 14 9.33579 14 9.75V14.25C14 14.6642 13.6642 15 13.25 15C12.8358 15 12.5 14.6642 12.5 14.25V9.75C12.5 9.33579 12.8358 9 13.25 9ZM6.75 13C7.16421 13 7.5 13.3358 7.5 13.75V14.25C7.5 14.6642 7.16421 15 6.75 15C6.33579 15 6 14.6642 6 14.25V13.75C6 13.3358 6.33579 13 6.75 13ZM10.75 11.75C10.75 11.3358 10.4142 11 10 11C9.58579 11 9.25 11.3358 9.25 11.75V14.25C9.25 14.6642 9.58579 15 10 15C10.4142 15 10.75 14.6642 10.75 14.25V11.75Z"
        fill="#7041F1"
        fillRule="evenodd"
      />
    </svg>
  );
};
